import { inputAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, defineStyle, } from '@chakra-ui/styled-system';
import { ThemeColorVariable } from '../../theme-types';
import { isTouchScreenDevice } from '../../theme-helper';
import { ThemeBorderToken, ThemeColorToken, ThemeFontSizeToken, ThemeFontToken, ThemeRadiusToken, ThemeSpaceToken, } from '../theme-tokens';
const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(parts.keys);
const field = {
    fontFamily: ThemeFontToken.Body,
    color: ThemeColorToken.OnSurface,
    border: ThemeBorderToken.XSmall,
    borderColor: ThemeColorToken.OnSurfaceBorder,
    background: ThemeColorToken.Surface,
    borderRadius: ThemeRadiusToken.Small,
    width: '100%',
    _disabled: {
        cursor: 'not-allowed',
        background: ThemeColorToken.SurfaceDisabled,
        color: ThemeColorToken.OnSurfaceSubdued,
        border: 0,
        opacity: 1,
    },
    _readOnly: {
        color: ThemeColorToken.OnSurface,
        background: ThemeColorToken.SurfaceDisabled,
        userSelect: 'text',
        opacity: 1,
        border: 0,
    },
    _placeholder: {
        color: ThemeColorToken.OnSurfaceSubdued,
        opacity: 1,
    },
    _invalid: {
        borderColor: ThemeColorToken.Error,
        boxShadow: `0 0 0 4px ${ThemeColorVariable.ErrorContainer}`,
    },
    _focus: {
        borderColor: ThemeColorToken.Info,
        boxShadow: `0 0 0 4px ${ThemeColorVariable.InfoContainer}`,
    },
    _hover: {
        borderColor: isTouchScreenDevice()
            ? ThemeColorToken.OnSurfaceBorder
            : ThemeColorToken.OnSurface,
        _disabled: undefined,
        _readOnly: undefined,
    },
};
const addon = {
    color: ThemeColorToken.OnSurface,
    background: ThemeColorToken.SurfaceDisabled,
    borderColor: ThemeColorToken.OnSurfaceBorder,
    borderRadius: ThemeRadiusToken.Small,
    px: ThemeSpaceToken.Medium,
    _disabled: {
        opacity: 1,
        cursor: 'not-allowed',
        background: ThemeColorToken.SurfaceDisabled,
    },
    _readOnly: {
        opacity: 1,
        background: ThemeColorToken.SurfaceDisabled,
    },
};
const element = {
    color: ThemeColorToken.OnSurface,
    _disabled: {
        opacity: 1,
        color: ThemeColorToken.OnSurfaceSubdued,
    },
};
const size = {
    lg: defineStyle({
        fontSize: ThemeFontSizeToken.Medium,
        px: ThemeSpaceToken.Medium,
    }),
    md: defineStyle({
        fontSize: ThemeFontSizeToken.Medium,
        px: ThemeSpaceToken.Small,
    }),
    sm: defineStyle({
        fontSize: ThemeFontSizeToken.Small,
        px: ThemeSpaceToken.Small,
    }),
};
const sizes = {
    lg: definePartsStyle({
        field: size.lg,
        addon: size.lg,
        element: size.lg,
    }),
    md: definePartsStyle({
        field: size.md,
        addon: size.md,
        element: size.md,
    }),
    sm: definePartsStyle({
        field: size.sm,
        addon: size.sm,
        element: size.sm,
    }),
};
const ghostVariant = definePartsStyle({
    field: {
        ...field,
        border: 'none',
        background: 'none',
        color: ThemeColorToken.OnSurface,
        _focus: {
            border: ThemeBorderToken.XSmall,
            borderColor: ThemeColorToken.Info,
            boxShadow: `0 0 0 4px ${ThemeColorVariable.InfoContainer}`,
            backgroundColor: ThemeColorToken.Surface,
        },
        '@media(hover: hover)': {
            '&:hover': {
                borderColor: ThemeColorToken.Info,
            },
            '&:hover:not(:focus)': {
                backgroundColor: ThemeColorToken.SurfaceDisabled,
                borderColor: ThemeColorToken.Info,
            },
        },
        _invalid: {
            border: ThemeBorderToken.XSmall,
            borderColor: ThemeColorToken.Error,
            boxShadow: `0 0 0 4px ${ThemeColorVariable.ErrorContainer}`,
        },
    },
    addon,
    element,
});
const variants = {
    outline: {
        field,
        addon,
        element,
    },
    ghost: ghostVariant,
};
export const inputConfig = defineMultiStyleConfig({
    sizes,
    variants,
    defaultProps: {
        variant: 'outline',
    },
});
//# sourceMappingURL=input-theme.js.map